// extracted by mini-css-extract-plugin
export default {"cta":"style_cta__+tgo+","containerContent":"style_containerContent__ZogTl","move-x":"style_move-x__-8Pa5","headIcon":"style_headIcon__sJRzO"};